import { useEffect, useState } from 'react';

import { listGroups, listRoles, listStudios, validateApiResponse } from '../../../services';

const mapApiRoleToUi = (role, studioNames) => ({
  id: role.id,
  name: role.name,
  kind: role.type,
  description: role.description ?? '',
  permissionCount: (role.permissions ?? []).length,
  studios: (role.studios ?? []).map((id) => ({ id, name: studioNames[id] ?? id })),
});

const mapApiGroupToUi = (group) => ({
  id: group.id,
  name: group.name,
  description: group.description ?? '',
  memberCount: group.member_count ?? group.memberCount ?? 0,
  members: (group.members_preview ?? []).map((m) => ({ id: m.id, name: m.name })),
});

/** Roles and groups the invite builder can assign, with the studio names its role cards show. */
export const useInviteOptions = () => {
  const [data, setData] = useState({ roles: [], groups: [], studios: [], loading: true, error: null });

  useEffect(() => {
    let mounted = true;
    Promise.all([listRoles(), listGroups(), listStudios()])
      .then(([rolesRes, groupsRes, studiosRes]) => {
        if (!mounted) return;
        const studios = validateApiResponse(studiosRes).body.items.map((s) => ({ id: s.id, name: s.name }));
        const studioNames = Object.fromEntries(studios.map((s) => [s.id, s.name]));
        setData({
          roles: validateApiResponse(rolesRes).body.items.map((r) => mapApiRoleToUi(r, studioNames)),
          groups: validateApiResponse(groupsRes).body.items.map(mapApiGroupToUi),
          studios,
          loading: false,
          error: null,
        });
      })
      .catch((error) => {
        if (mounted) setData({ roles: [], groups: [], studios: [], loading: false, error });
      });
    return () => {
      mounted = false;
    };
  }, []);

  return data;
};
